import { useState, useEffect, useRef } from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Chip,
  IconButton,
  alpha,
} from '@mui/material';
import {
  FavoriteBorder,
  Favorite,
  LocationOn,
  NavigateBefore,
  NavigateNext,
  Star,
  SquareFoot,
  Bathtub,
  Bed,
} from '@mui/icons-material';
import { investorApi } from '../../api/api';
import { useNavigate } from 'react-router-dom';
import GradientButton from '../common/GradiantButton';
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Loader from '../common/Loader';
import { useSelector } from 'react-redux';
import { toggleFavorite } from '../../redux/reducers/favoritesSlice';
import { useDispatch } from "react-redux";
import LoginModal from '../common/LoginModal';

export default function RecentPropertiesList({ userId, type, propertyId }) {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [favorites, setFavorites] = useState(new Set());
  const [showLeftScroll, setShowLeftScroll] = useState(false);
  const [showRightScroll, setShowRightScroll] = useState(true);
  const theme = useTheme();
   const dispatch = useDispatch();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const { isAuthenticated , user_refferal_code } = useSelector((state) => state.user);
   const favoriteItems = useSelector((state) => state.favorites.items);
   const [showLoginModal ,setShowLoginModal]=useState(false);
  const titleMap = {
    1: 'Similar Projects',
    2: 'Similar Properties',
    3: 'Similar Apartments',
    4: 'Similar Independent Villas',
  };

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await investorApi.getRecentProperties(
          { 
            // userId,
             type, propertyId });
        setList(response.data || []);
      } catch (error) {
        console.error('Error fetching recent properties:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProperties();
  }, [userId, type]);

  const handleFavorite = (propertyId, event) => {
    event.stopPropagation();
    setFavorites(prev => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(propertyId)) {
        newFavorites.delete(propertyId);
      } else {
        newFavorites.add(propertyId);
      }
      return newFavorites;
    });
  };

  const generateSlug = (property) => {
  const titlePart = `${property.name}-${property.city}`
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();

  return `${titlePart}-${property.id}`;
}; 
const handleViewDetails = (property) => {
  const slug = generateSlug(property);

  let basePath = "";

  if (property.type === "property") {
    basePath = `/property/${slug}`;
  } else if (property.type === "project") {
    basePath = `/project/${slug}`;
  } else if (property.type === "villa") {
    basePath = `/villa/${slug}`;
  } else if (property.type === "apartment") {
    basePath = `/apartment/${slug}`;
  }

  if (isAuthenticated && user_refferal_code) {
    basePath += `?ref=${user_refferal_code}`;
  }

  window.open(basePath, "_blank");
};
 

  // const handleViewDetails = (property) => {
  //   const path = property.type === 'property'
  //     ? `/PropertyDetailsScreen?${property.refferal_code}/${user_refferal_code}`
  //     : property.type === 'project'
  //       ? `/ProjectDetailsScreen?${property.refferal_code}/${user_refferal_code}`
  //       : property.type === 'villa'
  //         ? `/IndividualVillaScreen?${property.refferal_code}/${user_refferal_code}`
  //         : property.type === 'apartment'
  //           ? `/ApartmentPlotsScreen?${property.refferal_code}/${user_refferal_code}` : " ";

  //   navigate(path, {
  //     state: {
  //       propertyId: property.refferal_code,
  //       projectId: property.refferal_code,
  //       villaId: property.refferal_code,
  //       type: property.type
  //     },
  //   });
  //   window.open(path, "_blank");
  // };

  const checkScrollPosition = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setShowLeftScroll(scrollLeft > 0);
      setShowRightScroll(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 400;
      const newScrollLeft = direction === 'left'
        ? scrollContainerRef.current.scrollLeft - scrollAmount
        : scrollContainerRef.current.scrollLeft + scrollAmount;

      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });

      setTimeout(checkScrollPosition, 300);
    }
  };

  useEffect(() => {
    checkScrollPosition();
    window.addEventListener('resize', checkScrollPosition);
    return () => window.removeEventListener('resize', checkScrollPosition);
  }, [list]);

  if (loading) {
    return (
      <Box mt={4} display="flex" justifyContent="center">
        <Loader />
      </Box>
    );
  }

  const getUniqueId = ({ id, type }) => {
  return `${type}_${id}`;
};

   const toggleLike = (property) => {
      const uniqueId = getUniqueId(property);
      dispatch(toggleFavorite(uniqueId));
    };
  
    // Check like status for a full property object
    const isLiked = (property) => {
      const uniqueId = getUniqueId(property);
      return favoriteItems.includes(uniqueId);
    };

  if (!list.length) return null;

  const cardWidth = isXs ? 10 : isSm ? 300 : 200;
  return (
    <Box sx={{
      mt: 6,
      px: { xs: 2, sm: 3, md: 4 },
      maxWidth: { xs: '1500px', sm: '1400px', md: '1400px' },
      margin: '0 auto',
      position: 'relative',
      // backgroundColor: "blue",
      width: { xs: '350px', sm: '450px', md: '650px', lg: '1250px' }
    }}>
      {/* Header with Scroll Controls */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 0,
      }}>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: 'text.primary',

            }}
          >
            {titleMap[type]}
          </Typography>
        </Box>

        {/* Scroll Control Buttons */}
        {/* <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton
            onClick={() => scroll('left')}
            disabled={!showLeftScroll}
            sx={{
              width: 50,
              height: 40,
              borderRadius: '8px',
              backgroundColor: showLeftScroll ? 'primary.main' : 'grey.100',
              color: showLeftScroll ? 'white' : 'grey.400',
              '&:hover': showLeftScroll ? {
                backgroundColor: 'primary.dark',
              } : {},
            }}
          >
            <NavigateBefore />
          </IconButton>

          <IconButton
            onClick={() => scroll('right')}
            disabled={!showRightScroll}
            sx={{
              width: 40,
              height: 40,
              borderRadius: '8px',
              backgroundColor: showRightScroll ? 'primary.main' : 'grey.100',
              color: showRightScroll ? 'white' : 'grey.400',
              '&:hover': showRightScroll ? {
                backgroundColor: 'primary.dark',
              } : {},
            }}
          >
            <NavigateNext />
          </IconButton>
        </Box> */}
      </Box>

      {/* Cards Container with Side Scroll Buttons */}
      <Box sx={{ position: 'relative' }}>
        {/* Left Scroll Button - Floating */}
        {showLeftScroll && (
          <IconButton
            onClick={() => scroll('left')}
            sx={{
              position: 'absolute',
              left: -20,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 100,
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: 'primary.main',
              color: 'white',
              boxShadow: 2,
              border: '2px solid white',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
              display: { xs: 'none', md: 'flex' }
            }}
          >
            <NavigateBefore />
          </IconButton>
        )}

        {/* Right Scroll Button - Floating */}
        {showRightScroll && (
          <IconButton
            onClick={() => scroll('right')}
            sx={{
              position: 'absolute',
              right: -20,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 100,
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: 'primary.main',
              color: 'white',
              boxShadow: 2,
              border: '2px solid white',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
              display: { xs: 'none', md: 'flex' }
            }}
          >
            <NavigateNext />
          </IconButton>
        )}

        <Box
          sx={{
            position: "relative",
            width: "100%",
            overflow: "hidden",
            "&::before, &::after": {
              content: '""',
              position: "absolute",
              top: 15,
              width: 40,
              height: "85%",
              zIndex: 10,
              pointerEvents: "none",
            },

            "&::before": {
              left: 0,
              background: "linear-gradient(to right, rgba(255, 255, 355, 0.90), transparent)",
            },
            "&::after": {
              right: 0,
              background: "linear-gradient(to left, rgba(255, 255, 255, 0.90), transparent)",
            },
          }}
        >
          {/* Scrollable container */}
          <Box
            ref={scrollContainerRef}
            onScroll={checkScrollPosition}
            sx={{
              display: "flex",
              overflowX: "auto",
              gap: 3,
              py: 2,
              pb: 4,
              scrollSnapType: "x mandatory",
              "&::-webkit-scrollbar": { display: "none" },
              scrollbarWidth: "none",
              scrollBehavior: "smooth",
              maxWidth: { xs: "100%", sm: "100%" },
              paddingLeft: { xs: "20px", sm: "0px" },
            }}
          >

            {list.map((item) => (
              <Card
                key={item.id}
                sx={{
                  flex: '0 0 auto',
                  scrollSnapAlign: 'start',
                  borderRadius: 3,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  position: 'relative',
                  zIndex: 1,
                  overflow: 'hidden',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                  },
                  maxWidth: { xs: '100%', sm: "30%" },
                  width: { xs: '85%', sm: "30%" },
                  background: 'white',
                  border: '1px solid rgba(0,0,0,0.05)',
                  display: 'flex',
                  flexDirection: 'column',
                  height: 'auto',
                }}
              >
                {/* Favorite Button */}
                <IconButton
                  sx={{
                    position: 'absolute',
                    top: 12,
                    right: 12,
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    zIndex: 2,
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: 'white',
                      transform: 'scale(1.1)',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                    },
                  }}
                 onClick={() =>{
                  if(!userId){
                    setShowLoginModal(true);
                    return;
                  }
                  toggleLike({ id: item.id, type: item.type })
                 } }
                >
                 {isLiked({ id: item.id, type: item.type }) ? (
                        <FavoriteIcon style={{ color: 'red' }} />
                      ) : (
                        <FavoriteBorderIcon style={{ color: theme.normal_icon }} />
                      )}
                </IconButton>

                {/* Property Image Section */}
                <Box sx={{ position: 'relative', flexShrink: 0 }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={item.iconUrl}
                    alt={item.name}
                    sx={{
                      objectFit: 'cover',
                      transition: 'transform 0.5s ease',
                      '&:hover': {
                        transform: 'scale(1.05)',
                      },
                    }}
                  />

                  {/* Price Badge */}
                  {/* {item.price && (
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 16,
                        left: 0,
                        background: 'linear-gradient(90deg, rgba(0,0,0,0.8) 0%, transparent 100%)',
                        color: 'white',
                        padding: '6px 16px 6px 12px',
                        borderTopRightRadius: 16,
                        borderBottomRightRadius: 16,
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, fontSize: '0.95rem' }}>
                        {item.price}
                      </Typography>
                    </Box>
                  )} */}

                  {/* Property Type Badge */}
                  <Chip
                    label={item.type || 'Property'}
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: 16,
                      left: 16,
                      backgroundColor: 'rgba(255,255,255,0.95)',
                      backdropFilter: 'blur(10px)',
                      fontWeight: 600,
                      fontSize: '0.75rem',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      height: 28,
                    }}
                  />
                </Box>

                <CardContent sx={{ p: 2.5, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  {/* Property Title */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      fontSize: '1.1rem',
                      lineHeight: 1.3,
                      color: 'text.primary',
                      // minHeight: '2.8em',
                       textOverflow: 'ellipsis',
                    }}
                  >
                    {item.name}
                  </Typography>

                  {/* Location with Icon */}
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <LocationOn
                      sx={{
                        fontSize: 18,
                        color: 'text.secondary',
                        mr: 1,
                        mt: 0.2,
                        flexShrink: 0,
                      }}
                    />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        lineHeight: 1.4,
                        fontSize: '0.85rem',
                        flexGrow: 1,
                         textOverflow: 'ellipsis',
                      }}
                    >
                      {item.address}, {item.city}
                    </Typography>
                  </Box>

                  {/* Property Features - Horizontal Layout */}
                  {/* <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2.5,
                    p: 1.5,
                    backgroundColor: 'rgba(0,0,0,0.02)',
                    borderRadius: 2,
                    border: '1px solid rgba(0,0,0,0.05)',
                    gap: 1,
                  }}>
                    {item.bedrooms && (
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        flex: 1,
                        justifyContent: 'center',
                      }}>
                        <Bed sx={{ fontSize: 18, color: 'text.secondary' }} />
                        <Box>
                          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                            {item.bedrooms}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                            Beds
                          </Typography>
                        </Box>
                      </Box>
                    )}

                    {item.bathrooms && (
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        flex: 1,
                        justifyContent: 'center',
                        borderLeft: '1px solid rgba(0,0,0,0.1)',
                        borderRight: '1px solid rgba(0,0,0,0.1)',
                        px: 1,
                      }}>
                        <Bathtub sx={{ fontSize: 18, color: 'text.secondary' }} />
                        <Box>
                          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                            {item.bathrooms}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                            Baths
                          </Typography>
                        </Box>
                      </Box>
                    )}

                    {item.area && (
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        flex: 1,
                        justifyContent: 'center',
                      }}>
                        <SquareFoot sx={{ fontSize: 18, color: 'text.secondary' }} />
                        <Box>
                          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                            {item.area}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                            Sq Ft
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box> */}

                  {/* View Details Button */}
                  <Box sx={{ mt: 'auto' }}>
                    <GradientButton
                      text="View Details"
                      onClick={() => handleViewDetails(item)}
                      style={{
                        width: '100%',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: 600,
                        fontSize: '14px',
                        padding: '10px 16px',
                        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-1px)',
                          boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
                        },
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Box>
      </Box>
      {showLoginModal && 
      (
        <LoginModal onClose={()=>setShowLoginModal(false)} />
      )}
    </Box>
  );
} 